import React, { useId } from "react";
import PropTypes from "prop-types";
import SoftBox from "../SoftBox";
import SoftTypography from "../SoftTypography";
import SoftSelect from "../SoftSelect";

/** Shared brand selector with compact sizing and a green selected option. */
const BrandSelect = ({ brands = [], value, onChange }) => {
  const inputId = useId();
  if (brands.length < 2) return null;

  return (
    <SoftBox
      title={value?.label}
      sx={({ palette }) => ({
        width: { xs: "100%", sm: 320 },
        maxWidth: "100%",
        minWidth: 0,
        "& .brand-select__value-container": {
          position: "relative",
          minWidth: 0,
          height: "100%",
          overflow: "hidden",
        },
        "& .brand-select__single-value": {
          maxWidth: "calc(100% - 24px)",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: palette.dark.main,
        },
        "& .brand-select__menu": {
          border: "1px solid " + palette.grey[300],
          padding: "6px",
        },
        "& .brand-select__option": {
          padding: "10px 12px",
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          "& + .brand-select__option": { marginTop: "4px" },
          "&.brand-select__option--is-selected": {
            backgroundColor: palette.brand.main,
            color: palette.dark.main,
          },
          "&::after": { display: "none" },
        },
      })}
    >
      <SoftTypography
        component="label"
        htmlFor={inputId}
        variant="caption"
        fontWeight="medium"
        sx={{ display: "block", mb: 1, fontSize: 13 }}
      >
        Brand
      </SoftTypography>
      <SoftSelect
        inputId={inputId}
        classNamePrefix="brand-select"
        placeholder="Select brand"
        value={value}
        options={brands.map((brand) => ({ value: brand._id, label: brand.name }))}
        onChange={onChange}
      />
    </SoftBox>
  );
};

BrandSelect.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
};

export default BrandSelect;
